<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] rounded-md border-solid border-[#EFF0F1] tw-max-h-[100%] tw-overflow-auto tableWrapper"
    @scroll="onScroll"
  >
    <table class="tw-min-w-full tw-divide-y tw-divide-gray-200 table">
      <thead class="tw-sticky tw-top-0 tw-z-[1]">
        <tr
          :class="`tw-bg-[#FFF] tw-h-[44px] table-row !tw-border-0 ${headerWrapperClass}`"
        >
          <th v-if="draggable" class="tw-w-[18px] table-header"></th>
          <th
            v-if="showCheckboxRow"
            class="tw-min-w-[37px] tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-header"
          >
            <custom-check-box
              :class="`tw-h-[20px] !tw-mb-0 ${draggable ? '!tw-pl-0' : ''}`"
              size="20px"
              :color-checkmark="colorCheckmark"
              :is-checked="selectAll"
              @update:is-checked="(value) => onSelectAllChanged(value)"
            />
          </th>
          <th
            v-for="(column, index) in columns"
            :key="column.value"
            :class="`tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-header tw-pr-10 ${
              column.text === 'mfa enabled' ? 'tw-w-[104px]' : ''
            }`"
          >
            <span
              :id="`${column.headerWrapperId}`"
              :class="[
                `tw-flex tw-item-center tw-gap-[4px] tw-select-none tw-items-center`,
                column.headerClass ? column.headerClass : '',
                column.sortable ? 'tw-cursor-pointer' : '',
                columnActive === index
                  ? `!tw-text-[${textHeaderSortActiveDefault}]`
                  : `!tw-text-[${textHeaderDefault}]`,
              ]"
              @click="clickSortHeader(column, index)"
            >
              <span class="tw-w-[max-content]">
                {{ column.text }}
              </span>
              <span v-if="column.sortable">
                <SwapIcon
                  :color="
                    columnActive === index
                      ? textHeaderSortActiveDefault
                      : textHeaderDefault
                  "
                />
              </span>
            </span>
          </th>
        </tr>
      </thead>
      <VueDraggable
        v-show="!idItemExpland && !isLoading"
        :list="sortedData"
        tag="tbody"
        item-key="id"
        group="action"
        handle=".drag-handle"
        class="drag-drop-table"
        @change="changeItem"
      >
        <template #item="{ element }">
          <tr
            v-memo="[element]"
            :class="`table-row ${isGlobalSearch ? 'tw-cursor-pointer' : ''}`"
            :style="`background-color: ${
              selectedRows.includes(element.id)
                ? '#F2F8FF'
                : element.rowBgColor || ''
            }`"
          >
            <td
              v-if="draggable"
              :class="`tw-w-[18px] table-data !tw-pr-[10px] ${
                element.templateType !== templateType.system ||
                tableType !== tableTypeConstant.VENDORTEMPLATE
                  ? 'tw-cursor-pointer'
                  : ''
              }`"
            >
              <DraggableIcon
                v-if="
                  element.templateType !== templateType.system ||
                  tableType !== tableTypeConstant.VENDORTEMPLATE
                "
                class="drag-handle"
              />
            </td>
            <td
              v-if="showCheckboxRow"
              onmousedown="return false"
              class="!tw-w-[30px] tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-data"
            >
              <custom-check-box
                :type="type"
                class="!tw-mb-0 tw-h-[20px] !tw-pl-0"
                size="20px"
                :is-checked="selectedRows.includes(element.id)"
                @update:is-checked="() => toggleRow(element.id, element)"
              />
            </td>
            <td
              v-for="column in columns"
              :key="column.value"
              onmousedown="return false"
              :class="`tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 ${
                column.valueClass ? column.valueClass : ''
              } table-data`"
              @click="(e) => $emit('clicked-row', element, column, e)"
            >
              <slot
                :name="'cell(' + column.value + ')'"
                :table-prefix="'VueDraggableTable'"
                :value="element[column.value]"
                :item="element"
              >
                <template v-if="typeof column.render === 'function'">
                  <span
                    class="tw-flex tw-w-[max-content]"
                    @click="getAttachment(element)"
                    v-html="
                      getSafeHTML(
                        column.value === '*'
                          ? column.render(element)
                          : column.render(element[column.value]),
                      )
                    "
                  />
                </template>
                <template v-else>
                  {{ element[column.value] }}
                </template>
              </slot>
            </td>
          </tr>
        </template>
        <template #footer>
          <tr
            v-if="tableType === tableTypeConstant.ACTIONS && !data.length"
            key="footer"
            role="group"
            class="empty-action-table-footer"
          >
            <td colspan="7">
              <div
                class="tw-flex tw-flex-col tw-content-center tw-items-center tw-gap-[40px] tw-rounded-[6px] tw-bg-[#FFFFFF] tw-px-[25px] tw-py-[50px]"
              >
                <div
                  class="tw-text-center tw-font-[400] tw-leading-[145%] tw-text-[15px] tw-text-[#878787]"
                >
                  {{
                    getUiText(
                      "app-assess-recommendations-section-action-empty-action-table-title-1",
                    )
                  }}
                  <span class="add-button"
                    >{{
                      getUiText(
                        "app-assess-recommendations-section-action-empty-action-table-title-2",
                      )
                    }} </span
                  >,
                  {{
                    getUiText(
                      "app-assess-recommendations-section-action-empty-action-table-title-3",
                    )
                  }}
                </div>
                <span
                  class="tw-cursor-pointer tw-text-center tw-font-[500] tw-leading-[145%] tw-text-[11px] tw-text-[#387DFF]"
                  @click="handleAddAction"
                  >{{
                    getUiText(
                      "app-assess-recommendations-section-action-empty-action-table-sub-title-1",
                    )
                  }}
                </span>
              </div>
            </td>
          </tr>
          <tr
            v-if="
              tableType === tableTypeConstant.SUGGESTEDACTIONS && !data.length
            "
            key="footer"
            role="group"
            class="empty-action-table-footer"
          >
            <td colspan="7">
              <div
                class="empty-action-table tw-flex tw-flex-col tw-content-center tw-items-center tw-gap-[40px] tw-rounded-[6px] tw-bg-[#FFFFFF]"
              >
                <div
                  class="tw-text-center tw-font-[400] tw-leading-[145%] tw-text-[15px] tw-text-[#878787]"
                >
                  {{
                    getUiText(
                      "app-assess-recommendations-section-action-empty-suggest-action-table-title-1",
                    )
                  }}
                </div>
              </div>
            </td>
          </tr>
        </template>
      </VueDraggable>
      <tbody v-if="isRecommend || idItemExpland" v-show="idItemExpland">
        <template v-for="item in sortedData" :key="item.id">
          <tr
            class="table-row"
            :style="`background-color: ${
              selectedRows.includes(item.id) ? '#F2F8FF' : item.rowBgColor || ''
            } `"
          >
            <td
              v-if="draggable"
              class="tw-w-[18px] table-data !tw-pr-[10px] tw-cursor-pointer"
            >
              <DraggableIcon />
            </td>
            <td
              v-if="showCheckboxRow"
              class="!tw-w-[30px] tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-data"
            >
              <custom-check-box
                :id="item.id"
                class="!tw-mb-0 tw-h-[20px] !tw-pl-0"
                size="20px"
                :color-checkmark="colorCheckmark"
                :is-checked="selectedRows.includes(item.id)"
                @update:is-checked="() => toggleRow(item.id, item)"
              />
            </td>
            <td
              v-for="column in columns"
              :key="column.value"
              :class="`tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 ${
                column.valueClass ? column.valueClass : ''
              } table-data`"
              @click="(e) => $emit('clicked-row', item, column, e)"
            >
              <slot
                :name="'cell(' + column.value + ')'"
                :value="item[column.value]"
                :item="item"
              >
                <template v-if="typeof column.render === 'function'">
                  <span
                    class="tw-flex tw-w-[max-content]"
                    @click="getAttachment(item)"
                    v-html="
                      getSafeHTML(
                        column.value === '*'
                          ? column.render(item)
                          : column.render(item[column.value]),
                      )
                    "
                  />
                </template>
                <template v-else>
                  {{ item[column.value] }}
                </template>
              </slot>
            </td>
          </tr>
          <!-- detail -->
          <tr v-show="item.id === idItemExpland" class="detail">
            <td :colspan="columns.length + 2" class="detail_content">
              <slot
                :name="'detail'"
                :item="item"
                :value="item.id === idItemExpland"
              >
              </slot>
            </td>
          </tr>
        </template>
      </tbody>
      <!-- List empty -->
      <tbody
        v-if="
          !isLoading &&
          !data?.length &&
          (tableType === tableTypeConstant.ASSESSMENTTABLE ||
            tableType === tableTypeConstant.VENDORTEMPLATE)
        "
      >
        <tr class="tr-empty">
          <td :colspan="showCheckboxRow ? columns.length + 2 : columns.length">
            <div
              class="tw-w-full tw-text-[#878787] tw-text-[13px] tw-font-medium tw-text-center"
              style="font-family: Poppins"
            >
              <span>{{ emptyText || "" }}</span>
            </div>
          </td>
        </tr>
      </tbody>

      <!-- skeleton loading -->
      <tbody
        v-if="isLoading || isLoadingNewData"
        class="!tw-border-t-[1px] !tw-border-0 !tw-border-solid !tw-border-[#EFF0F1]"
      >
        <TableSkeleton
          :rows-number="isLoadingNewData ? 1 : 3"
          :columns-number="
            columns.length + (draggable ? 1 : 0) + (showCheckboxRow ? 1 : 0)
          "
        />
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import Utils from "@/utils/utilities";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import TableSkeleton from "@/components/common/skeleton/tableSkeleton.vue";
import DraggableIcon from "@/components/svgs/draggableIcon.vue";
import SwapIcon from "@/components/svgs/swapIcon.vue";
import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { computed, ref } from "vue";
import VueDraggable from "vuedraggable";
import cloneDeep from "lodash/cloneDeep";
import {
  DRAG_AND_DROP_TABLE_TYPE,
  RECOMMENDATION_FORCE_RESORT,
  templateType,
  VALUE_SORT_COLUMN_ACTION_MODAL,
} from "@/utils/constants";
export type CustomTableColumn = {
  text: string;
  value: string;
  sortable?: boolean;
  headerClass?: string;
  valueClass?: string;
  render?: any;
  sortDefault?: boolean;
  headerWrapperId?: string;
};

@Component({
  components: {
    CustomCheckBox: CustomCheckBox,
    TableSkeleton: TableSkeleton,
    DraggableIcon: DraggableIcon,
    SwapIcon: SwapIcon,
    VueDraggable,
  },
  emits: [
    "update-selected-rows",
    "clickSortColumn",
    "updatedData",
    "added",
    "removed",
    "moved",
    "currentImage",
    "add-all-selected",
    "scroll-to-end",
    "clicked-row",
  ],
})
export default class CustomTable extends Vue {
  @Prop({ type: Array, required: true })
  columns!: CustomTableColumn[];

  @Prop({ type: Boolean, required: false, default: false })
  isActionTable?: boolean;

  @Prop({ type: Array, required: true })
  data!: Array<any>;

  @Prop({ default: false })
  isAccessible!: boolean;

  @Prop({ type: String, required: false })
  emptyText?: string;

  @Prop({ type: String, required: false })
  type?: string;

  @Prop({ type: Boolean, required: false, default: false })
  isLoading?: boolean;

  @Prop({ required: false, default: null })
  idItemExpland?: any;

  @Prop({ required: false, default: false })
  draggable?: boolean;

  @Prop({ required: false, default: "" })
  headerWrapperClass?: boolean;

  @Prop({ required: false, default: true })
  showCheckboxRow?: boolean;

  @Prop({ required: false, default: "desc" })
  sortDirection = "desc";

  @Prop({ required: false, default: false })
  questionBeforeSort?: boolean;

  @Prop({ required: false, default: true })
  reorderable?: boolean;

  @Prop({ required: false, default: undefined })
  toSorted?: (sortColumnBy: string, sortDirections: string) => Array<any>;

  @Prop({ required: false, default: "" })
  selectedChildrenIdsKey = "";

  @Prop({ required: false, default: "#387dff" })
  readonly colorCheckmark: string = "";

  @Prop({ required: false, default: false })
  isLoadingScrollToEnd = false;

  @Prop({ required: false, default: DRAG_AND_DROP_TABLE_TYPE.ACTIONS })
  readonly tableType: string = "";

  @Prop({ required: false, default: false })
  isGlobalSearch = false;

  @Prop({ required: false, default: "" })
  headerWrapperId = "";

  @Prop({ required: false, default: false })
  isRecommend = false;

  selectedRows: Array<number> = [];
  selectAll = false;
  columnActive = -1;
  sortColumnBy = "";
  textHeaderDefault = "#878787";
  textHeaderSortActiveDefault = "#211F58";
  sortDirections = this.sortDirection;
  isDraging = false;
  listData: any[] = [];
  timer: any = null;
  lastScrollTop = 0;
  delta = 5;
  isLoadingNewData = false;
  tableTypeConstant = DRAG_AND_DROP_TABLE_TYPE;
  templateType = templateType;
  dataLength = 0;
  isSortByScore = false;

  mounted() {
    const columnIndex = this.columns.findIndex((i) => i.sortDefault === true);
    columnIndex >= 0 && (this.columnActive = columnIndex);
    columnIndex >= 0 && (this.sortColumnBy = this.columns[columnIndex].value);
    if (this.isActionTable) {
      EventEmitter.on(EmitterEvents.RESET_SORT_TABLE, (emitData: any) => {
        if (!emitData && !this.isDraging) {
          this.columnActive = 3;
        } else {
          if (
            (emitData &&
              emitData.key === RECOMMENDATION_FORCE_RESORT.isForce) ||
            (emitData &&
              emitData.key === RECOMMENDATION_FORCE_RESORT.isInit &&
              !this.isSortByScore)
          ) {
            this.isSortByScore = false;
            this.columnActive = -1;
          }
        }
      });
    }

    EventEmitter.on(
      EmitterEvents.CLICK_SORT_COLUMN_ACTION_TABLE,
      (emitData: any) => {
        if (this.questionBeforeSort) {
          setTimeout(() => {
            this.isSortByScore = true;
          }, 5000);
          if (!emitData.column.sortable) return;
          this.columnActive = emitData?.index;
          this.sortColumn(emitData.column.value);
        }
      },
    );
    EventEmitter.on(EmitterEvents.REMOVE_ITEM_SELECTED_ROW, () => {
      this.selectedRows = [];
    });
  }
  meals = ref([
    { id: 1, name: "1", sport: "basket" },
    { id: 2, name: "2", sport: "foot" },
    { id: 3, name: "3", sport: "volley" },
    { id: 4, name: "4", sport: "rugby" },
  ]);

  beforeDestroy() {
    EventEmitter.off(EmitterEvents.CLICK_SORT_COLUMN_ACTION_TABLE);
    EventEmitter.off(EmitterEvents.RESET_SORT_TABLE);
    EventEmitter.off(EmitterEvents.REMOVE_ITEM_SELECTED_ROW);
  }

  get sortedData() {
    if (this.tableType === this.tableTypeConstant.VENDORTEMPLATE) {
      return this.data;
    }
    let data: any;
    if (!this.reorderable && !this.toSorted) {
      data = this.sortData();
    } else {
      data = cloneDeep(this.data);
    }
    this.isLoadingNewData = false;

    const newLength = data.length;
    if (newLength > this.dataLength) {
      this.dataLength = newLength;
      this.selectAll = false;
    }
    return data;
  }

  onSelectAllChanged(value: boolean) {
    this.selectedRows = value ? this.data.map((item) => item.id) : [];
    this.selectAll = value;
  }

  get dataSelected() {
    return store.state.Recommend.selectedActionsRow;
  }

  @Watch("dataSelected")
  onCheckSelectedRow() {
    if (this.dataSelected.length === 0) {
      this.onSelectAllChanged(false);
    }
  }

  @Watch("selectedRows")
  onSelectedRowsChanged(oldValue: number[], newValue: number[]) {
    if (oldValue.length === 0 && newValue.length === 0) {
      return;
    }
    this.$emit("update-selected-rows", this.selectedRows);
  }

  getSafeHTML(htmlText: string) {
    return Utils.sanitizeHTML(htmlText);
  }

  public defaultUiText = computed(
    () => store.state.LanguagePicker.defaultUiText,
  );

  public languageSelectedText = computed(
    () => store.state.LanguagePicker.languageSelectedText,
  );

  public test = computed(() => {
    return store.state.Recommend.loadingActionTable;
  });

  getUiText = (id: string, isArray = false) => {
    return Utils.getUiText(
      id,
      this.languageSelectedText.value,
      this.defaultUiText.value,
      isArray,
    );
  };

  clickSortHeader(column: CustomTableColumn, index: number) {
    if (!column?.sortable) return;
    this.$emit("clickSortColumn", column, index);
    if (!this.questionBeforeSort) {
      this.columnActive = index;
      this.sortColumn(column.value);
    }
  }

  sortColumn(column) {
    if (column !== VALUE_SORT_COLUMN_ACTION_MODAL.scoreIncreaseTotal) {
      this.isSortByScore = false;
    } else {
      this.isSortByScore = true;
    }
    this.isDraging = false;
    if (column === this.sortColumnBy) {
      this.sortDirections = this.sortDirections === "asc" ? "desc" : "asc";
    } else {
      this.sortColumnBy = column;
      this.sortDirections = "asc";
    }
    this.toSorted?.(this.sortColumnBy, this.sortDirections);
    this.sortData();
  }

  sortData() {
    const data = cloneDeep(this.data);
    if (this.sortColumnBy && this.sortDirections) {
      const isAscending = this.sortDirections === "asc";
      data.sort((a, b) => {
        const valueA =
          this.sortColumnBy === "scoreIncreaseTotal"
            ? +a.scoreIncreaseTotal.toFixed(2) -
              +a.scoreIncreaseFirstCount.toFixed(2)
            : a[this.sortColumnBy];
        const valueB =
          this.sortColumnBy === "scoreIncreaseTotal"
            ? +b.scoreIncreaseTotal.toFixed(2) -
              +b.scoreIncreaseFirstCount.toFixed(2)
            : b[this.sortColumnBy];
        if (typeof valueA === "string" && typeof valueB === "string") {
          return isAscending
            ? valueA.localeCompare(valueB)
            : valueB.localeCompare(valueA);
        } else {
          return isAscending ? valueA - valueB : valueB - valueA;
        }
      });
      if (this.reorderable) this.$emit("updatedData", data);
    }
    return data;
  }
  changeItem(data) {
    if (this.tableType === this.tableTypeConstant.VENDORTEMPLATE) {
      const moved = data.moved || {};
      let itemChanged;
      if (moved.newIndex > moved.oldIndex) {
        itemChanged = this.data[moved.newIndex - 1];
      } else {
        itemChanged = this.data[moved.newIndex + 1];
      }
      if (itemChanged.templateType === templateType.system) {
        this.data.splice(moved.newIndex, 1);
        this.data.splice(moved.oldIndex, 0, moved.element);
        return;
      }
    }
    if (this.reorderable) {
      this.isDraging = true;
      this.isSortByScore = false;
      this.columnActive = -1;
    }
    if (data.added) {
      // We'll look for the element below the position we want to add and add it on top of it
      const actionIndex =
        data.added.newIndex > this.data.length - 1
          ? this.data.length - 1
          : data.added.newIndex;
      const dataAdded = {
        element: data.added.element,
        newBelowElement: this.data[actionIndex],
        isSuggestionsAction: !data.added.element.checklistItemId,
      };
      this.$emit("added", dataAdded);
    } else if (data.removed) {
      const newItem = {
        elementId: data.removed.element.id,
        isAssessmentTable:
          this.tableType === this.tableTypeConstant.ASSESSMENTTABLE
            ? true
            : false,
      };
      this.$emit("removed", newItem);
    } else if (data.moved && this.reorderable) {
      this.$emit("moved", data.moved);
    }
  }
  getAttachment(item) {
    this.$emit("currentImage", item);
  }
  toggleRow(rowId: number, item: any = {}) {
    const index = this.selectedRows.indexOf(rowId);
    if (this.tableType !== this.tableTypeConstant.ASSESSMENTTABLE) {
      if (index > -1) {
        this.selectedRows.splice(index, 1);
        this.$emit("update-selected-rows", this.selectedRows);
      } else {
        this.selectedRows = this.selectedRows.filter(
          (id) => this.data.findIndex((element) => element.id === id) !== -1,
        );
        this.selectedRows.push(rowId);
      }
      return;
    }
    if (index > -1) {
      // unselected
      this.selectedRows.splice(index, 1);

      // unselected children
      const loop = (arr: any[]) => {
        arr?.forEach((child) => {
          if (child.id) {
            const i = this.selectedRows.indexOf(child.id);
            if (i > -1) {
              this.selectedRows.splice(i, 1);
            }
            loop(child[this.selectedChildrenIdsKey]);
          }
        });
      };
      loop(item[this.selectedChildrenIdsKey]);

      // unselected parent
      item?.checklistItemPathId?.forEach((id) => {
        const i = this.selectedRows.indexOf(id);
        if (i > -1) {
          this.selectedRows.splice(i, 1);
        }
      });

      // unselected all
      this.selectAll = false;

      this.$emit("update-selected-rows", this.selectedRows);
      return;
    }

    // selected
    this.selectedRows.push(rowId);

    // selected children
    const loop = (arr: any[]) => {
      arr?.forEach((child) => {
        if (child.id && !this.selectedRows.includes(child.id)) {
          this.selectedRows.push(child.id);
          loop(child[this.selectedChildrenIdsKey]);
        }
      });
    };
    loop(item[this.selectedChildrenIdsKey]);

    // selected parent
    let parentId = item.checklistId;

    while (parentId) {
      const parent = this.data.find(
        (item) => item.checklistItemId === parentId,
      );
      if (parent) {
        parentId = parent.checklistId;
        const isSelectedAll = parent?.[this.selectedChildrenIdsKey]?.every(
          (child: any) => this.selectedRows.includes(child.id),
        );
        if (isSelectedAll && parent?.id) {
          this.selectedRows.push(parent.id);
        }
      } else {
        parentId = "";
        break;
      }
    }

    // selected all
    if (this.selectedRows.length === this.data.length) {
      this.selectAll = true;
    }

    this.$emit("update-selected-rows", this.selectedRows);
  }
  handleAddAction() {
    this.$emit("add-all-selected");
  }
  onScroll(event: any) {
    const isScrollDown = event.target.scrollTop > this.lastScrollTop;
    const isScrollToBottom =
      isScrollDown &&
      event.target.scrollHeight - event.target.scrollTop <=
        event.target.clientHeight + this.delta;

    this.lastScrollTop = event.target.scrollTop;
    if (isScrollToBottom) {
      this.isLoadingNewData = this.isLoadingScrollToEnd;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.$emit("scroll-to-end"), 1000); // timeout for show loading
    }
  }
}
</script>

<style scoped>
.tableWrapper {
  background: #ffffff;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid #eff0f1 !important;
}

.table {
  display: table;
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0px;
}

.table * {
  border: none;
}

.table-header {
  /* padding-right: 40px; */
  /* padding-top: 17.5px;
  padding-bottom: 17.5px; */
  padding-top: 0.5px;
  padding-bottom: 0.5px;
  vertical-align: middle;
  max-height: 40px;
  padding-left: 0px;
}

.table-header:first-child {
  padding-left: 25px;
  padding-right: 0px;
}

.table-row {
  display: table-row;
  border-top: 1px solid #eff0f1;
}

.detail {
  border-top: 1px solid #eff0f1;
}

.detail_content {
  padding: 0px;
}

.table-data {
  /* display: table-cell;
  padding: 10px; Adjust the padding as needed */
  padding-right: 40px;
  vertical-align: middle;
  padding: 18px 25px;
  padding-left: 0px;
  /* line-height: 100%; */
}

.table-data:first-child {
  padding-left: 25px;
  padding-right: 0px;
}

/* .table-row:nth-child(even) {
  background-color: #fcfcfd;
} */

.tr-empty {
  height: 56px;
}

.empty-action-table {
  padding: 50px 25px;
  align-self: stretch;
  border-radius: 6px;
  border: 1px dashed var(--UI-white, #ffffff);
  background: var(--UI-white, #ffffff);
  .add-button {
    color: var(--UI-dark-grey, #878787);
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 145%;
  }
}
</style>
